module.exports = __webpack_public_path__ + "76c2709b21c9eb0743c93bf4749368ca.pdf";